function getMemberKey(member) {
  const email = member?.email?.trim().toLowerCase();
  if (email) return email;

  const name = member?.name ?? "";
  const slug = name.includes(" - ")
    ? name.split(" - ")[0].trim().toLowerCase()
    : name.trim().toLowerCase();
  return slug || String(member?.id ?? "");
}

function pickPreferredMember(existing, candidate) {
  if (candidate.coordination && !existing.coordination) return candidate;
  if (existing.coordination && !candidate.coordination) return existing;
  return existing;
}

export function dedupeProjectTeam(team) {
  if (!Array.isArray(team)) return [];

  const byKey = new Map();
  for (const member of team) {
    const key = getMemberKey(member);
    if (!key) continue;

    const existing = byKey.get(key);
    if (!existing) {
      byKey.set(key, member);
    } else {
      byKey.set(key, pickPreferredMember(existing, member));
    }
  }

  return Array.from(byKey.values());
}
